<script setup lang="ts">
const emit = defineEmits(['done'])

const $box = useTemplateRef('$box')
const $container = useTemplateRef('$container')

const ease = {
  inQuint: 'cubic-bezier(0.64, 0, 0.78, 0)',
  outQuint: 'cubic-bezier(0.22, 1, 0.36, 1)',
  inOutQuint: 'cubic-bezier(0.83, 0, 0.17, 1)',
}

onMounted(async () => {
  await new Promise((r) => setTimeout(r, 200))

  if ($box.value) $box.value.style.opacity = '1'

  const introTarget = document.querySelector('[data-intro-target]')

  await $box.value?.animate(
    [{ transform: 'skew(-20deg) scale(0)' }, { transform: 'skew(-20deg) scale(8.5)' }],
    { duration: 800, fill: 'forwards', easing: ease.inQuint },
  ).finished

  setTimeout(async () => {
    if (introTarget) {
      introTarget.animate(
        [
          { scale: 2, transformOrigin: `center ${window.innerHeight / 2 + window.scrollY}px` },
          { scale: 1, transformOrigin: `center ${window.innerHeight / 2 + window.scrollY}px` },
        ],
        {
          duration: 2000,
          easing: ease.outQuint,
        },
      )
    }

    await $container.value?.animate(
      [
        {
          mask: 'url(/logomark.svg) center/0vw no-repeat, linear-gradient(black)',
          maskComposite: 'exclude',
        },
        {
          mask: 'url(/logomark.svg) center/200vmax no-repeat, linear-gradient(black)',
          maskComposite: 'exclude',
        },
      ],
      { duration: 800, fill: 'forwards', easing: ease.inQuint },
    ).finished

    emit('done', true)
  }, 400)
})
</script>

<template>
  <div ref="$container" class="text-neon-yellow fixed z-1000 h-screen w-full bg-black">
    <div
      ref="$box"
      class="bg-neon-yellow absolute top-1/2 left-1/2 z-1 h-[15vmax] w-[15vmax] -translate-1/2 -skew-x-[20deg] opacity-0"
    />
  </div>
</template>
